import { Injectable } from '@angular/core';
import { MeasurementDTO } from '@core/apis/measurement/measurement.dto';
import { IMeasurementOs } from '@core/apis/measurement/measurement.interface';

@Injectable({
  providedIn: 'root',
})
export class CsvOsMeasurementService {
  private row = '';
  private line = '';
  private row0 = '';
  private m_M_last = '';
  private headers1 = [
    'id',
    'patientId',
    'staffId',
    'clinicId',
    'userWhoSentType',
    'registrationDate',
    'requestedDate',
    'computedDate',
    'type',
    'status',
    'createdAt',
    'updatedAt',
  ];

  private headers1_device = ['name', 'macId', 'model', 'serialNumber'];

  private headers2 = ['segment', 'fs', 'errorStatus'];

  private headers3 = [
    'sdnnPos',
    'nn50Pos',
    'pnn50Pos',
    'sdsdPos',
    'moPos',
    'aMoPos',
    'bpPos',
    'ivrPos',
    'vprPos',
    'inPos',
    'hvrIndexPos',
    'mxDMnPos',
    'siPos',
    'hrPos',
    'l1Pos',
    'l2Pos',
    'sdnnNeg',
    'nn50Neg',
    'pnn50Neg',
    'sdsdNeg',
    'moNeg',
    'aMoNeg',
    'bpNeg',
    'ivrNeg',
    'vprNeg',
    'inNeg',
    'hvrIndexNeg',
    'mxDMnNeg',
    'siNeg',
    'hrNeg',
    'l1Neg',
    'l2Neg',
    'rrPosStd',
    'rrPosMean',
    'rrNegStd',
    'rrNegMean',
    'systola',
    'systolaCalc',
    'diastola',
    'diastolaCalc',
    'heartRate',
    'map',
    'pp',
    'powerStd',
    'bpm',
    'rmssd',
    'pars',
    'parsInt',
    'v',
    'ifsp',
    'ivhh',
    'ichh',
    'ivvh',
    'icvh',
  ];

  private headers4 = ['m1', 'm2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10', 'ms'];

  private headers_HilbertHuang_pos_neg_interval = [
    'ulf',
    'vlf',
    'lf',
    'hf',
    'total04',
    'perUlf',
    'perVlf',
    'perLf',
    'perHf',
  ];

  private headers_FFT_pos_ned_interval = [
    'ulf',
    'vlf',
    'lf',
    'hf',
    'total04',
    'perUlf',
    'perVlf',
    'perLf',
    'perHf',
    'k',
  ];

  private headers_HilbertHuang = [
    'ulf',
    'vlf',
    'lf',
    'hf',
    'alpha',
    'beta',
    'teta',
    'delta',
    'fx25x60',
    'total04',
    'total025',
    'perUlf',
    'perVlf',
    'perLf',
    'perHf',
    'perDelta',
    'perTeta',
    'perAlpha',
    'perBeta',
  ];

  private headers_FFT = [
    'ulf',
    'vlf',
    'lf',
    'hf',
    'alpha',
    'beta',
    'teta',
    'delta',
    'total04',
    'total025',
    'k',
    'perUlf',
    'perVlf',
    'perLf',
    'perHf',
    'perAlpha',
    'perBeta',
    'perDelta',
    'perTeta',
  ];

  private headers5 = ['hurstTotal', 'hurst0to20', 'hurst20to70', 'hurst70to100', 'hurst100to70', 'hurst70toEnd'];
  private headers6 = ['arrhythmiaDegree', 'heartDiseases', 'ag1', 'ag2', 'lungDiseases', 'psychicalDiseases'];
  constructor() {}

  private headers(header: Array<any>) {
    header.forEach((v) => {
      this.row += v + ';';
      this.row0 += ';';
    });
  }

  private info(header: Array<any>, obj: any, toString?: boolean) {
    header.forEach((v) => {
      if (obj[v] != null && obj[v] != 'undefined') {
        if (toString) this.line += obj[v]?.toString().replace('.', ',') + ';';
        else this.line += obj[v] + ';';
      } else this.line += '-;';
    });
  }

  private last(header: Array<any>, objs: any, str: string, toString?: boolean) {
    let array: any = [];
    objs.map((v: any) => {
      let value = v;
      str.split('.').forEach((s: any) => {
        value = value[s];
      });
      array.push(value);
    });
    header.forEach((v) => {
      let M = 0;
      let errCounter = 0;
      array.forEach((a: any) => {
        if (a[v]) M += a[v];
        else errCounter++;
      });
      let currArrLength = array.length - errCounter;
      let stdev = 0;

      array.forEach((a: any) => {
        if (a[v]) stdev += (a[v] - M / currArrLength) * (a[v] - M / currArrLength);
      });
      this.m_M_last +=
        (M / currArrLength).toFixed(2)?.toString().replace('.', ',') +
        '±' +
        Math.sqrt(stdev / (currArrLength - 1) / currArrLength)
          .toFixed(2)
          ?.toString()
          .replace('.', ',') +
        ';';
    });
  }

  public convertToCSV(objArray: MeasurementDTO[]) {
    if (objArray?.length > 1) {
      this.m_M_last = 'M ± m;;;;;;;;;;;;;';

      this.m_M_last += ';;;;';

      this.m_M_last += ';;;;;';

      this.last(this.headers3, objArray, 'records.results.timeAnalysis');
      this.m_M_last += ';';

      this.last(this.headers4, objArray, 'records.results.morphologicalAnalysis');
      this.m_M_last += ';';

      this.last(this.headers_FFT, objArray, 'records.results.spectralAnalysis.fft');
      this.m_M_last += ';';

      this.last(this.headers_HilbertHuang, objArray, 'records.results.spectralAnalysis.hilbertHuang');
      this.m_M_last += ';';

      this.last(this.headers_FFT_pos_ned_interval, objArray, 'records.results.spectralAnalysis.fftPosInterval');
      this.m_M_last += ';';

      this.last(this.headers_FFT_pos_ned_interval, objArray, 'records.results.spectralAnalysis.fftNegInterval');
      this.m_M_last += ';';

      this.last(
        this.headers_HilbertHuang_pos_neg_interval,
        objArray,
        'records.results.spectralAnalysis.hilbertHuangPosInterval',
      );
      this.m_M_last += ';';

      this.last(
        this.headers_HilbertHuang_pos_neg_interval,
        objArray,
        'records.results.spectralAnalysis.hilbertHuangNegInterval',
      );

      this.last(this.headers5, objArray, 'records.results.fractalAnalysis');

      this.last(this.headers6, objArray, 'records.results.expertSystem');
    }

    this.row = '';
    this.line = '';
    this.row0 = '';
    this.headers(this.headers1);
    this.row += ';';
    this.row0 += 'device;';
    this.headers(this.headers1_device);
    this.row += ';';
    this.row0 += 'records;';
    this.headers(this.headers2);
    this.row += ';';
    this.row0 += 'timeAnalysis;';
    this.headers(this.headers3);
    this.row += ';';
    this.row0 += 'morphologicalAnalysis;';
    this.headers(this.headers4);
    this.row += ';';
    this.row0 += 'FFT;';
    this.headers(this.headers_FFT);
    this.row += ';';
    this.row0 += 'HilbertHuang;';
    this.headers(this.headers_HilbertHuang);
    this.row += ';';
    this.row0 += 'FFT_pos_interval;';
    this.headers(this.headers_FFT_pos_ned_interval);
    this.row += ';';
    this.row0 += 'FFT_neg_interval;';
    this.headers(this.headers_FFT_pos_ned_interval);
    this.row += ';';
    this.row0 += 'HilbertHuang_pos_interval;';
    this.headers(this.headers_HilbertHuang_pos_neg_interval);
    this.row += ';';
    this.row0 += 'HilbertHuang_neg_interval;';
    this.headers(this.headers_HilbertHuang_pos_neg_interval);
    this.headers(this.headers5);
    this.headers(this.headers6);

    objArray.forEach((obj: MeasurementDTO) => {
      const vOsc = obj['records'] as IMeasurementOs;
      this.info(this.headers1, obj);
      this.line += ';';
      this.info(this.headers1_device, obj['device']?.[0], true);
      this.line += ';';
      this.info(this.headers2, vOsc, true);
      this.line += ';';
      this.info(this.headers3, vOsc.results.timeAnalysis, true);
      this.line += ';';
      this.info(this.headers4, vOsc.results.morphologicalAnalysis, true);
      this.line += ';';
      this.info(this.headers_FFT, vOsc.results.spectralAnalysis.fft, true);
      this.line += ';';
      this.info(this.headers_HilbertHuang, vOsc.results.spectralAnalysis.hilbertHuang, true);
      this.line += ';';
      this.info(this.headers_FFT_pos_ned_interval, vOsc.results.spectralAnalysis.fftPosInterval, true);
      this.line += ';';
      this.info(this.headers_FFT_pos_ned_interval, vOsc.results.spectralAnalysis.fftNegInterval, true);
      this.line += ';';
      this.info(
        this.headers_HilbertHuang_pos_neg_interval,
        vOsc.results.spectralAnalysis.hilbertHuangPosInterval,
        true,
      );
      this.line += ';';
      this.info(
        this.headers_HilbertHuang_pos_neg_interval,
        vOsc.results.spectralAnalysis.hilbertHuangNegInterval,
        true,
      );
      this.info(this.headers5, vOsc.results.fractalAnalysis, true);
      this.info(this.headers6, vOsc.results.expertSystem, true);
      this.line += '\r\n';
    });
    return this.row0 + '\r\n' + this.row + '\r\n' + this.line + this.m_M_last + '\r\n';
  }
}
